module.exports = __webpack_public_path__ + "img/w3_bookmark_solid_white.7dfe6567.png";